module.exports = __webpack_public_path__ + "img/adrian.68bc6d47.png";